import Billing from "views/SubscriptionView";

export default function Page() {
  return (
    <>
      <Billing />
    </>
  );
}
